import { MamSource, MamStatus, MamType } from "../../domain/mam-explorer";

// ── Dropdown option types ───────────────────────────────────

export interface FilterOption<T> {
  value: T | "All";
  label: string;
}

// ── Status (matches GetMediaList MediaStatusFilter) ─────────

export const STATUS_OPTIONS: FilterOption<MamStatus>[] = [
  { value: "All", label: "All Statuses" },
  { value: MamStatus.Ready, label: "Ready" },
  { value: MamStatus.Uploading, label: "Uploading" },
];

export const STATUS_META: Record<
  MamStatus,
  { label: string; cssClass: string }
> = {
  [MamStatus.Ready]: { label: "Ready", cssClass: "status--ready" },
  [MamStatus.Uploading]: {
    label: "Uploading",
    cssClass: "status--processing",
  },
  [MamStatus.Deleted]: { label: "Deleted", cssClass: "status--deleted" },
};

// ── Source (display only; no list API filter) ───────────────

export const SOURCE_LABELS: Record<MamSource, string> = {
  [MamSource.Ready]: "Ready",
  [MamSource.Upload]: "Uploading",
  [MamSource.Recorded]: "Recorded",
};

// ── Type ────────────────────────────────────────────────────

export const TYPE_OPTIONS: FilterOption<MamType>[] = [
  { value: "All", label: "All Types" },
  { value: MamType.Video, label: "Video" },
  { value: MamType.Audio, label: "Audio" },
];

export const TYPE_LABELS: Record<MamType, string> = {
  [MamType.Video]: "Video",
  [MamType.Audio]: "Audio",
};
